// src/components/Login.js

import React, { useState, useEffect } from 'react';
import { FaArrowUpRight } from 'react-icons/fa'; // Import icons
import { useNavigate, Link } from 'react-router-dom';
import supabase from '../supabase';
import WinningCup from '../assets/Winning Cup.png'; // Import the image

const quotes = [
  "The best way to predict the future is to create it. - Peter Drucker",
  "Success usually comes to those who are too busy to be looking for it. - Henry David Thoreau",
  "Don’t be afraid to give up the good to go for the great. - John D. Rockefeller",
  "If you are not willing to risk the usual, you will have to settle for the ordinary. - Jim Rohn",
];

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [currentQuote, setCurrentQuote] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        navigate('/dashboard');
      }
    };

    checkSession();
  }, [navigate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentQuote((prev) => (prev + 1) % quotes.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleLogin = async () => {
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setMessage(`Error: ${error.message}`);
    } else {
      setMessage('Login successful!');
      navigate('/dashboard');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-md">
        {/* Header */}
        <div className="flex justify-center mb-2">
          <img src={WinningCup} alt="Winning Cup" className="w-24 h-24" />
        </div>

        <h1 className="mt-4 text-2xl font-bold text-center text-black-800"> 
          Business Portal
        </h1>
        
        <p className="mt-4 text-sm text-center text-black-500">
          Sign-in to access your profile & account features
        </p>

        {/* Email Input */}
        <div className="mt-6">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2 mt-2 text-sm text-blue-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
          />
        </div>

        {/* Password Input */}
        <div className="mt-4">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2 mt-2 text-sm text-blue-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
          />
        </div>

        {/* Login Button */}
        <button
          onClick={handleLogin}
          className="w-full flex items-center justify-center px-4 py-2 mt-4 text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-yellow-400"
        >
          Login
        </button>

        {/* Forgot Password Link */}
        <p className="mt-2 text-sm text-center text-blue-600">
          <Link to="/password-reset" className="text-yellow-500 hover:underline">
            Forgot Password?
          </Link>
        </p>

        {/* Sign Up Link */}
        <p className="mt-4 text-sm text-center text-blue-600">
          Don't have an account?{' '}
          <Link to="/signup" className="text-yellow-500 hover:underline">
            Sign Up
          </Link>
        </p>

        {/* Message */}
        {message && <p className="mt-4 text-sm text-center text-red-500">{message}</p>}

        {/* Rotating Quote */}
        <p className="text-sm italic text-center text-gray-600 mt-6">
          "{quotes[currentQuote]}"
        </p>
      </div>
    </div>
  );
};

export default Login;
